module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "uib-tooltip": "Oculta ou Mostra o histórico de alterações da Entidade",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.mostraHistorico = !_vm.mostraHistorico
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.mostraHistorico ? 'Ocultar histórico' : 'Mostrar histórico'))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostraHistorico),
      expression: "mostraHistorico"
    }],
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "bordered": _vm.table.bordered,
      "items": _vm.table.items,
      "hover": _vm.table.hover,
      "fields": _vm.table.fields,
      "filter": _vm.table.filter,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "inicio",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "DD/MM/YYYY HH:mm")))]
      }
    }, {
      key: "termino",
      fn: function(row) {
        return [(row.value !== null) ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(row.value, "DD/MM/YYYY HH:mm")))]) : (row.value === null) ? _c('span', [_vm._v("-")]) : _vm._e()]
      }
    }, {
      key: "nome",
      fn: function(row) {
        return [(row.value === 'SOLICITACAO') ? _c('span', [_vm._v("Solicitação")]) : _vm._e(), _vm._v(" "), (row.value === 'REVISAO') ? _c('span', [_vm._v("Em Revisão")]) : _vm._e(), _vm._v(" "), (row.value === 'ANALISE') ? _c('span', [_vm._v("Análise")]) : _vm._e(), _vm._v(" "), (row.value === 'ANULACAO') ? _c('span', [_vm._v("Anulação")]) : _vm._e(), _vm._v(" "), (row.value === 'DEFERIMENTO') ? _c('span', [_vm._v("Deferimento")]) : _vm._e(), _vm._v(" "), (row.value === 'FORMALIZACAO') ? _c('span', [_vm._v("Formalização")]) : _vm._e(), _vm._v(" "), (row.value === 'APROVACAO') ? _c('span', [_vm._v("Aprovação")]) : _vm._e()]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [_c('div', [(row.item.termino) ? _c('b-button', {
          staticClass: "btn btn-primary btn-sm btn-flat",
          attrs: {
            "type": "button",
            "disabled": false
          },
          on: {
            "click": function($event) {
              _vm.showModal = true, _vm.testFunc(row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-search",
          attrs: {
            "aria-hidden": "true"
          }
        })]) : _vm._e()], 1)]
      }
    }])
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6",
      "right": ""
    }
  }, [_c('b-pagination', {
    staticClass: "my-3",
    attrs: {
      "total-rows": _vm.table.items.length,
      "per-page": _vm.table.perPage
    },
    model: {
      value: (_vm.table.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.table, "currentPage", $$v)
      },
      expression: "table.currentPage"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.loadingShow) ? _c('div', {
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.showModal) ? _c('div', [_c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        return _vm.$emit(_vm.showModal = false)
      }
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Histórico")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('fieldset', {
    attrs: {
      "disabled": true
    }
  }, [_c('div', {
    staticClass: "form-horizontal ng-valid-maxlength ng-invalid ng-invalid-required ng-valid-date ng-invalid-min ng-dirty ng-valid-mask ng-valid-parse"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('legend', [_vm._v("Projeto ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-10 required",
    class: {
      'has-error': _vm.errors.first('nome')
    }
  }, [_c('div', [(_vm.snap.ds_codigo_projeto_erp) ? _c('div', [_c('label', {}, [_vm._v("Número do projeto ")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.idProjectErp",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.ds_codigo_projeto_erp),
      expression: "proposta.ds_codigo_projeto_erp"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": true,
      "name": "idProjectErp",
      "type": "text",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.proposta.ds_codigo_projeto_erp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "ds_codigo_projeto_erp", $event.target.value)
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Nome do projeto ")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.name"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.snap.ds_nome),
      expression: "snap.ds_nome"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255'),
      expression: "'required|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nome",
      "data-vv-as": "Nome da Proposta",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.snap.ds_nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.snap, "ds_nome", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('nome')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('legend', [_vm._v("Responsável pela Proposta")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12 required",
    class: {
      'has-error': _vm.errors.first('nome do coordenador')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.coordinatorName"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.snap.ds_nome_coordenador),
      expression: "snap.ds_nome_coordenador"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:100'),
      expression: "'required|max:100'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nome do coordenador",
      "type": "text",
      "data-vv-as": "Nome do Coordenador",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.snap.ds_nome_coordenador)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.snap, "ds_nome_coordenador", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('nome do coordenador')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome do coordenador')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12 required",
    class: {
      'has-error': _vm.errors.first('cpf do coordenador')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("CPF")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.coordinatorCpf"
    }
  }, [(this.$router.currentRoute.name === 'proposta-visualiza') ? _c('the-mask', {
    staticClass: "form-control",
    attrs: {
      "name": "cpf do coordenador",
      "type": "text",
      "data-vv-as": "CPF do Coordenador",
      "mask": '###.###.###-##'
    },
    model: {
      value: (_vm.snap.ds_cpf_coordenador),
      callback: function($$v) {
        _vm.$set(_vm.snap, "ds_cpf_coordenador", $$v)
      },
      expression: "snap.ds_cpf_coordenador"
    }
  }) : _vm._e(), _vm._v(" "), (this.$router.currentRoute.name !== 'proposta-visualiza') ? _c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('cpf|required'),
      expression: "'cpf|required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cpf do coordenador",
      "type": "text",
      "mask": '###.###.###-##'
    },
    model: {
      value: (_vm.snap.ds_cpf_coordenador),
      callback: function($$v) {
        _vm.$set(_vm.snap, "ds_cpf_coordenador", $$v)
      },
      expression: "snap.ds_cpf_coordenador"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.errors.first('cpf do coordenador')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('cpf do coordenador')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12 required",
    class: {
      'has-error': _vm.errors.first('email do coordenador')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.coordinatorEmail"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.snap.ds_email_coordenador),
      expression: "snap.ds_email_coordenador"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email|max:255'),
      expression: "'required|email|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email do coordenador",
      "type": "email",
      "data-vv-as": "E-mail do Coordenador",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.snap.ds_email_coordenador)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.snap, "ds_email_coordenador", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('email do coordenador')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('email do coordenador')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('Telefone')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.coordinatorPhone"
    }
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Telefone",
      "type": "tel",
      "data-vv-as": "Telefone do Coordenador",
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.snap.ds_telefone_coordenador),
      callback: function($$v) {
        _vm.$set(_vm.snap, "ds_telefone_coordenador", $$v)
      },
      expression: "snap.ds_telefone_coordenador"
    }
  }), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Telefone Celular")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.coordinatorPhone"
    }
  }, [_c('the-mask', {
    staticClass: "form-control",
    attrs: {
      "name": "Telefone Celular",
      "type": "tel",
      "data-vv-as": "Celular do Coordenador",
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.snap.ds_celular_coordenador),
      callback: function($$v) {
        _vm.$set(_vm.snap, "ds_celular_coordenador", $$v)
      },
      expression: "snap.ds_celular_coordenador"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('legend', [_vm._v("Período de execução do projeto")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: " col-md-12 ng-scope required",
    class: {
      'has-error': _vm.errors.first('Data Inicial')
    },
    staticStyle: {
      "margin-left": "-15px"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data inicial ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "ng-isolate-scope",
    attrs: {
      "name": "proposal.initialDate"
    }
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "Data Inicial",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "data-vv-as": "Data Inicial",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.snap.dt_data_inicial),
      callback: function($$v) {
        _vm.$set(_vm.snap, "dt_data_inicial", $$v)
      },
      expression: "snap.dt_data_inicial"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12 ng-scope required",
    class: {
      'has-error': _vm.errors.first('periodo')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Número de meses do projeto")]), _vm._v(" "), _c('div', {
    staticClass: "ng-isolate-scope",
    attrs: {
      "name": "proposal.periods"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.snap.nr_periodos),
      expression: "snap.nr_periodos"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:1'),
      expression: "'required|min_value:1'"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-invalid ng-not-empty ng-invalid-min ng-valid-required",
    attrs: {
      "data-vv-as": "Número de Meses do Projeto",
      "lang": "pt-br",
      "name": "periodo",
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": (_vm.snap.nr_periodos)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.snap, "nr_periodos", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('periodo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('periodo')))]) : _vm._e()]), _vm._v(" "), _c('dl', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-left": "-15px"
    }
  }, [_c('dt', [_vm._v("Data final de execução:")]), _vm._v(" "), _c('dd', {
    staticClass: "ng-binding"
  }, [_vm._v(_vm._s(_vm.dataFinal))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "text-left box-header"
  }, [(_vm.esconderEntidade === false) ? _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.esconderEntidade = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Mostrar dados da Entidade - "), _c('span', {
    staticStyle: {
      "color": "steelblue",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.proposta.entidade.ds_nome))])]) : _vm._e(), _vm._v(" "), (_vm.esconderEntidade === true) ? _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.esconderEntidade = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ocultar dados da Entidade - "), _c('span', {
    staticStyle: {
      "color": "steelblue",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.proposta.entidade.ds_nome))])]) : _vm._e()]), _vm._v(" "), (_vm.esconderEntidade === true) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('legend', [_vm._v("Dados da Entidade")]), _vm._v(" "), _c('dl', {
    staticClass: "proposal-definition-list"
  }, [_c('dt', [_vm._v("Entidade")]), _vm._v(" "), _c('dd', {
    staticClass: "ng-binding"
  }, [_c('router-link', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'right',
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    attrs: {
      "title": 'Ir para o Cadastro da entidade',
      "to": {
        name: 'cadastro-entidade-visualiza',
        params: {
          id: _vm.proposta.entidade.id
        }
      },
      "target": "_blank"
    }
  }, [_vm._v(" " + _vm._s(_vm.proposta.entidade.ds_nome) + "  "), _c('i', {
    staticClass: "fa fa-external-link"
  })])], 1), _vm._v(" "), _c('dt', [_vm._v("CNPJ")]), _vm._v(" "), _c('dd', [_vm._v("\n                                    " + _vm._s(_vm._f("cnpj")(_vm.snap.entidade.ds_cnpj)) + "\n                                  ")]), _vm._v(" "), _c('dt', [_vm._v("E-mail")]), _vm._v(" "), _c('dd', {
    staticClass: "ng-binding"
  }, [_vm._v(_vm._s(_vm.snap.entidade.ds_email))]), _vm._v(" "), _c('dt', [_vm._v("Endereço")]), _vm._v(" "), (_vm.snap.entidade.endereco) ? _c('dd', {
    staticClass: "ng-binding"
  }, [_vm._v(_vm._s(_vm.snap.entidade.endereco[0].ds_rua) + ", " + _vm._s(_vm.snap.entidade.endereco[0].ds_numero) + " -\n                                    " + _vm._s(_vm.snap.entidade.endereco[0].ds_bairro) + ", " + _vm._s(_vm.snap.entidade.endereco[0].ds_cidade) + " - " + _vm._s(_vm.snap.entidade.endereco[0].ds_estado) + "\n                                  ")]) : _vm._e(), _vm._v(" "), _c('dt', [_vm._v("Telefone")]), _vm._v(" "), _c('dd', {
    attrs: {
      "id": "phone"
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.telefone) + "\n                                  ")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Informações do Projeto")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field required-field col-md-12 ng-scope",
    class: {
      'has-error': _vm.errors.first('introducao')
    }
  }, [_c('label', {
    staticClass: "control-label ",
    attrs: {
      "for": "introduction"
    }
  }, [_vm._v("Introdução")]), _vm._v(" "), _c('div', {
    staticClass: "ng-isolate-scope"
  }, [_c('textarea', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.snap.ds_introducao),
      expression: "snap.ds_introducao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Ver texto padrão com a GEPRO...",
      "name": "introducao",
      "data-vv-as": "Informações Introdutórias do Projeto",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.snap.ds_introducao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.snap, "ds_introducao", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12 ng-scope required",
    class: {
      'has-error': _vm.errors.first('apresentacao')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "presentation"
    }
  }, [_vm._v("Apresentação")]), _vm._v(" "), _c('div', {
    staticClass: "ng-isolate-scope",
    attrs: {
      "name": "proposal.presentation"
    }
  }, [_c('textarea', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.snap.ds_apresentacao),
      expression: "snap.ds_apresentacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
    attrs: {
      "placeholder": "Ver texto padrão com a GEPRO...",
      "data-vv-as": "Apresentação do Projeto",
      "name": "apresentacao",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.snap.ds_apresentacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.snap, "ds_apresentacao", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12 ng-scope required",
    class: {
      'has-error': _vm.errors.first('territorio')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "territory"
    }
  }, [_vm._v("Território de desenvolvimento do projeto")]), _vm._v(" "), _c('div', {
    staticClass: "ng-isolate-scope",
    attrs: {
      "name": "proposal.territory"
    }
  }, [_c('textarea', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.snap.ds_territorio),
      expression: "snap.ds_territorio"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
    attrs: {
      "placeholder": "Ver texto padrão com a GEPRO...",
      "data-vv-as": "Território de Desenvolvimento do Projeto",
      "name": "territorio",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.snap.ds_territorio)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.snap, "ds_territorio", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12 ng-scope required",
    class: {
      'has-error': _vm.errors.first('justificativa')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "justification"
    }
  }, [_vm._v("Justificativa")]), _vm._v(" "), _c('div', {
    staticClass: "ng-isolate-scope",
    attrs: {
      "name": "proposal.justification"
    }
  }, [_c('textarea', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.snap.ds_justificativa),
      expression: "snap.ds_justificativa"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
    attrs: {
      "placeholder": "Ver texto padrão com a GEPRO...",
      "data-vv-as": "Justificativa do Projeto",
      "name": "justificativa",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.snap.ds_justificativa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.snap, "ds_justificativa", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12 ng-scope required",
    class: {
      'has-error': _vm.errors.first('objetivo Geral')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "generalObjective"
    }
  }, [_vm._v("Objetivo geral")]), _vm._v(" "), _c('div', {
    staticClass: "ng-isolate-scope",
    attrs: {
      "name": "proposal.generalObjective"
    }
  }, [_c('textarea', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.snap.ds_objetivo_geral),
      expression: "snap.ds_objetivo_geral"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-not-empty ng-valid ng-valid-required",
    attrs: {
      "placeholder": "Ver texto padrão com a GEPRO...",
      "data-vv-as": "Objetivo Geral do Projeto",
      "name": "objetivo Geral",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.snap.ds_objetivo_geral)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.snap, "ds_objetivo_geral", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('Resultados esperados')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "results"
    }
  }, [_vm._v("Resultados esperados")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.results"
    }
  }, [_c('textarea', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.snap.ds_resultados),
      expression: "snap.ds_resultados"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Ver texto padrão com a GEPRO...",
      "data-vv-as": "Resultados Esperados do Projeto",
      "name": "Resultados esperados",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.snap.ds_resultados)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.snap, "ds_resultados", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('Operacionalização')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "operation"
    }
  }, [_vm._v("Operacionalização")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.operation"
    }
  }, [_c('textarea', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.snap.ds_operacao),
      expression: "snap.ds_operacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Ver texto padrão com a GEPRO...",
      "data-vv-as": "Operacionalização do Projeto",
      "name": "Operacionalização",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.snap.ds_operacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.snap, "ds_operacao", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('Parceria')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "partner"
    }
  }, [_vm._v("Parceria")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.partner"
    }
  }, [_c('textarea', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.snap.ds_parceria),
      expression: "snap.ds_parceria"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Ver texto padrão com a GEPRO...",
      "data-vv-as": "Parceria do Projeto",
      "name": "Parceria",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.snap.ds_parceria)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.snap, "ds_parceria", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12 ng-scope required",
    class: {
      'has-error': _vm.errors.first('sumario')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Resumo")]), _vm._v(" "), _c('div', {
    staticClass: "ng-isolate-scope",
    attrs: {
      "name": "proposal.summary"
    }
  }, [_c('textarea', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.snap.ds_resumo),
      expression: "snap.ds_resumo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-not-empty ng-valid ng-valid-required",
    attrs: {
      "placeholder": "Ver texto padrão com a GEPRO...",
      "data-vv-as": "Resumo do Projeto",
      "name": "sumario",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.snap.ds_resumo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.snap, "ds_resumo", $event.target.value)
      }
    }
  })])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Público-alvo")])])]), _vm._v(" "), _c('publico-alvo', {
    attrs: {
      "propsPublicosGrid": _vm.snap.publicos_alvo
    },
    on: {
      "publicoAlvoAdicionado": function($event) {
        _vm.snap.publicos_alvo = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Equipe do Projeto")])])]), _vm._v(" "), _c('equipe-projeto', {
    attrs: {
      "propsEquipes": _vm.snap.equipes
    },
    on: {
      "equipeAdicionada": function($event) {
        _vm.snap.equipes = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.usuarioLogado.userType === 'FUNDACAO'),
      expression: "usuarioLogado.userType === 'FUNDACAO'"
    }],
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Projeto de duplicação")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group col-md-12 required",
    class: {
      'has-error': _vm.errors.first('Projeto Duplicação')
    },
    attrs: {
      "uib-tooltip": "Projeto de duplicação"
    }
  }, [_c('div', {
    attrs: {
      "name": "proposal.duplicateProject"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.snap.nr_projeto_duplicacao),
      expression: "snap.nr_projeto_duplicacao"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Projeto Duplicação",
      "aria-hidden": "true"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.snap, "nr_projeto_duplicacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.arvoreProjetos), function(projeto) {
    return _c('option', {
      domProps: {
        "value": projeto.projectNumber
      }
    }, [_vm._v(_vm._s(projeto.projectNumber + ' / ' + projeto.projectName))])
  }), 0)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Objetivo Específico")])])]), _vm._v(" "), _c('objetivo-especifico', {
    attrs: {
      "propsObjetivos": _vm.snap.objetivos
    },
    on: {
      "objetivoAdicionado": function($event) {
        _vm.snap.objetivos = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Metas")])])]), _vm._v(" "), _c('metas', {
    attrs: {
      "propsObjetivos": _vm.snap.objetivos,
      "propsMetas": _vm.snap.metas
    },
    on: {
      "metaAdicionada": function($event) {
        _vm.snap.metas = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Atividades")])])]), _vm._v(" "), _c('atividades', {
    attrs: {
      "meses": _vm.snap.nr_periodos,
      "propsMetas": _vm.snap.metas,
      "propsAtividades": _vm.snap.atividades
    },
    on: {
      "atividadeAdicionada": function($event) {
        _vm.snap.atividades = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Cronograma Físico-Financeiro")])])]), _vm._v(" "), _c('cronograma', {
    key: _vm.componentKey,
    attrs: {
      "propsObjetivos": _vm.proposta.objetivos,
      "propsAtividades": _vm.proposta.atividades,
      "metas": _vm.proposta.metas,
      "proposta": _vm.proposta,
      "meses": _vm.proposta.nr_periodos,
      "projeto-duplicacao": _vm.proposta.nr_projeto_duplicacao
    },
    on: {
      "itemAdicionado": function($event) {
        _vm.proposta.atividades = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Parcela de Adiantamento")])]), _vm._v(" "), _c('parcela-adiantamento', {
    attrs: {
      "propsParcelas": _vm.snap.adiantamentos,
      "propsAtividades": _vm.snap.atividades
    },
    on: {
      "parcelaAdicionada": function($event) {
        _vm.snap.adiantamentos = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "modal-body"
  }), _vm._v(" "), _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Municípios - Locais de execução")])])])]), _vm._v(" "), _c('municipalizacao', {
    attrs: {
      "proposta": _vm.snap
    },
    on: {
      "municipioAdicionado": function($event) {
        _vm.snap.municipalizacao = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Cursos")])])]), _vm._v(" "), _c('cursos', {
    attrs: {
      "propsCursos": _vm.snap.cursos
    }
  })], 1)], 1)])]), _vm._v(" "), (_vm.fase === 'PRE_ANALISE' && _vm.termino !== null) ? _c('fieldset', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.usuarioLogado.userType === 'FUNDACAO'),
      expression: "usuarioLogado.userType === 'FUNDACAO'"
    }],
    attrs: {
      "disabled": true
    }
  }, [_c('pre-analise-form', {
    attrs: {
      "propsPreAnalise": _vm.snap
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.fase === 'ANALISE' && _vm.termino !== null) ? _c('fieldset', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.usuarioLogado.userType === 'FUNDACAO'),
      expression: "usuarioLogado.userType === 'FUNDACAO'"
    }],
    attrs: {
      "disabled": true
    }
  }, [_c('analise', {
    attrs: {
      "propsAnalise": _vm.snap
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.fase === 'DEFERIMENTO' && _vm.termino !== null) ? _c('fieldset', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.usuarioLogado.userType === 'FUNDACAO'),
      expression: "usuarioLogado.userType === 'FUNDACAO'"
    }],
    attrs: {
      "disabled": true
    }
  }, [_c('deferimento', {
    attrs: {
      "propsDeferimento": _vm.snap
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('br'), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-primary btn-sm btn-flat",
    attrs: {
      "type": "button",
      "disabled": false
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Fechar ")])], 1)])])])])])])], 1) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('pre', {
    ref: "myDiv",
    attrs: {
      "id": "myDiv"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-40389502!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/historicoProposta.vue
// module id = 1921
// module chunks = 1